<template>
    <div class="content-layout padded">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading">Reset password</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="auth-container">
                        <form class="auth-form" @submit.prevent="send" @keydown="form.onKeydown($event)">
                            <alert-success :form="form" :message="status"/>
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label>Email</label>
                                    <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" type="email" name="email" class="form-control" placeholder="Your login email address">
                                    <has-error :form="form" field="email"/>
                                </div>
                            </div>

                            <!-- Submit Button -->
                            <div class="form-group">
                                <v-button :loading="form.busy">Send Reset Link</v-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from 'vform'

export default {
    data: () => ({
        status: '',
        form: new Form({
            email: ''
        })
    }),

    head () {
        return { title: 'Reset Password' }
    },

    mounted () {
        this.$bvModal.hide('modal-login')
    },

    methods: {
        send () {
            this.form.post('/password/email').then(({ data }) => {
                this.status = data.status
                this.form.reset()
            })
        }
    }
}
</script>
